import { render, staticRenderFns } from "./OrderablePreviewBillingAddress.vue?vue&type=template&id=52115eba&"
import script from "./OrderablePreviewBillingAddress.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewBillingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports